import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Button } from "../../../components/Wrappers/Wrappers";
import FilterTableComponent from "./FilterTableComponent";

export default function ClaimList(){
    const { t } = useTranslation();

    return(
        <div>
            
            <PageTitle title={ t('claimSettlement.title')} button={<Link to="/app/search-dividend"> <Button
      variant="contained"
      size="medium"
      color="primary"
    >
        { t('claimSettlement.sideBarMainTitle')}
    </Button></Link>} />
    
            <FilterTableComponent />
        </div>
    )
}